import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager';

import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

const DEFAULT_TTL_SEEN = 60 * 60 * 24 * 30; // ~1 month

export const experimentalSetHaveISeenIt: ExperimentalMutations['experimentalSetHaveISeenIt'] = (
	_,
	{ flagKey },
	{ network: { cfetch } },
) =>
	cfetch('/gateway/api/flag/my', {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify({
			flagKey,
		}),
	}).then(() => {
		const now = new Date();
		const localStorageKey = `cf_hisi_${flagKey}`;
		localStorage.setItem(
			localStorageKey,
			JSON.stringify({
				status: true,
				lastSeenDate: now.toISOString(),
			}),
			DEFAULT_TTL_SEEN,
		);
		return true;
	});
